import { ModuleWithProviders, NgModule } from '@angular/core';

import { DataFormService } from './data.form.service';
import { TemplateFormService } from './template.form.service';

@NgModule()
export class CmpsFormModule {
    static forRoot(): ModuleWithProviders<CmpsFormModule> {
        return {
            ngModule: CmpsFormModule,
            providers: [TemplateFormService, DataFormService],
        };
    }
}
